import api from "./api";
import isEmpty from "lodash/isEmpty";
import findLast from "lodash/findLast";

export const addProductToCart = (
  currentProductAdded,
  finalQuantity,
  participateRewardsProgram
) => {
  let addedProduct = null;

  if (
    currentProductAdded.promocao_quantidade_multipla &&
    finalQuantity >=
      currentProductAdded.preco_quantidade_multipla[0]?.quantidade_multipla
  ) {
    const { quantityWithPromotion, quantityWithoutPromotion } =
      checksPricePromotionByMultipleQuantity(
        currentProductAdded,
        finalQuantity
      );

    const finalPriceWithRewardsProgram =
      currentProductAdded.preco_quantidade_multipla.find(
        (preco) => preco.programa_fidelidade
      );
    const finalPriceWithoutRewardsProgram =
      currentProductAdded.preco_quantidade_multipla.find(
        (preco) => !preco.programa_fidelidade
      );

    if (
      !participateRewardsProgram &&
      !isEmpty(finalPriceWithRewardsProgram) &&
      isEmpty(finalPriceWithoutRewardsProgram)
    ) {
      addedProduct = addProduct(
        currentProductAdded,
        finalQuantity,
        participateRewardsProgram
      );
      addedProduct.tipo_promocao = "SEM_PROMOCAO_POR_QUANTIDADE";
    } else {
      if (
        participateRewardsProgram &&
        !isEmpty(finalPriceWithRewardsProgram) &&
        quantityWithPromotion > 0
      ) {
        addedProduct = {
          ...currentProductAdded,
          promocao_aplicada: true,
          tipo_promocao: "PROMOCAO_QUANTIDADE_MULTIPLA",
          quantidade: quantityWithPromotion,
          preco_mostrar_cesta: finalPriceWithRewardsProgram,
          brotherQuantity: quantityWithoutPromotion,
        };
      } else if (
        quantityWithPromotion > 0 &&
        !isEmpty(finalPriceWithoutRewardsProgram)
      ) {
        addedProduct = {
          ...currentProductAdded,
          promocao_aplicada: true,
          tipo_promocao: "PROMOCAO_QUANTIDADE_MULTIPLA",
          quantidade: quantityWithPromotion,
          preco_mostrar_cesta: finalPriceWithoutRewardsProgram,
          brotherQuantity: quantityWithoutPromotion,
        };
      }

      if (quantityWithoutPromotion > 0) {
        const newProduct = addProduct(
          currentProductAdded,
          quantityWithoutPromotion,
          participateRewardsProgram
        );
        newProduct.brotherQuantity = quantityWithPromotion;
        newProduct.tipo_promocao = "SEM_PROMOCAO_POR_QUANTIDADE";
        addedProduct = newProduct;
      }
    }
  } else if (currentProductAdded.promocao_quantidade_minima) {
    const finalPriceWithRewardsProgram = findLast(
      currentProductAdded.preco_quantidade_minima,
      (preco) =>
        preco.quantidade_minima <= finalQuantity && preco.programa_fidelidade
    );

    const finalPriceWithoutRewardsProgram = findLast(
      currentProductAdded.preco_quantidade_minima,
      (preco) =>
        preco.quantidade_minima <= finalQuantity && !preco.programa_fidelidade
    );

    if (participateRewardsProgram && !isEmpty(finalPriceWithRewardsProgram)) {
      addedProduct = {
        ...currentProductAdded,
        promocao_aplicada: true,
        quantidade: finalQuantity,
        preco_mostrar_cesta: finalPriceWithRewardsProgram,
        tipo_promocao: "PROMOCAO_QUANTIDADE_MINIMA",
      };
    } else if (!isEmpty(finalPriceWithoutRewardsProgram)) {
      addedProduct = {
        ...currentProductAdded,
        promocao_aplicada: true,
        quantidade: finalQuantity,
        preco_mostrar_cesta: finalPriceWithoutRewardsProgram,
        tipo_promocao: "PROMOCAO_QUANTIDADE_MINIMA",
      };
    } else {
      addedProduct = addProduct(
        currentProductAdded,
        finalQuantity,
        participateRewardsProgram
      );
    }
  } else {
    addedProduct = addProduct(
      currentProductAdded,
      finalQuantity,
      participateRewardsProgram
    );
  }

  return addedProduct;
};

const addProduct = (product, quantity, participateRewardsProgram) => {
  if (
    !isEmpty(product.preco_programa_fidelidade) &&
    participateRewardsProgram
  ) {
    return {
      ...product,
      quantidade: quantity,
      promocao_aplicada: true,
      preco_mostrar_cesta: product.preco_programa_fidelidade,
      tipo_promocao: "SEM_PROMOCAO_POR_QUANTIDADE",
    };
  }

  return {
    ...product,
    quantidade: quantity,
    promocao_aplicada: false,
    preco_mostrar_cesta: !isEmpty(product.preco_normal) ? product.preco_normal : product.precos[0],
    tipo_promocao: "SEM_PROMOCAO_POR_QUANTIDADE",
  };
};

const checksPricePromotionByMultipleQuantity = (product, quantity) => {
  //Pega o quociente da divisão multiplicado pelo dividor (Quantidade do produto com promoção)
  let quantityWithPromotion =
    Math.trunc(
      quantity / product.preco_quantidade_multipla[0].quantidade_multipla
    ) * product.preco_quantidade_multipla[0].quantidade_multipla;

  //Pega o resto da divisão (Quantidade do produto sem promoção)
  let quantityWithoutPromotion =
    quantity % product.preco_quantidade_multipla[0].quantidade_multipla;

  return { quantityWithPromotion, quantityWithoutPromotion };
};

// `cartHashId`: quando a cesta foi aberta pelo link da venda assistida, o servidor passa a
// considerar exatamente esse carrinho como o aberto do cliente.
export async function syncLocalCartToAPI(userUuid, cartHashId = null) {
  const cart = JSON.parse(localStorage.getItem("@ConexaoGAM:cart"));

  // `cart?.itens.map(...)` devolvia `undefined` quando não havia carrinho de
  // convidado e a requisição saía sem corpo. O payload é sempre um array.
  const model = (cart?.itens ?? []).map((item) => {
    return {
      productId: item.id,
      quantity: item.quantidade,
    };
  });

  const getCurrentCartresponse = await api.post(`/cart/sync`, model, {
    params: cartHashId ? { cartHashId } : undefined,
  });
  const serverCart = getCurrentCartresponse.data;

  // O carrinho de convidado só é descartado depois que o servidor confirma a
  // persistência. `carrinhoId: 0` é o que a API devolve quando não encontrou
  // carrinho nenhum (CartController.syncItems) — se enviamos itens e recebemos
  // isso, nada foi gravado e a chave `@ConexaoGAM:cart` precisa sobreviver para
  // uma nova tentativa. Não exigimos `itens.length > 0` de propósito: quando o
  // produto foi despublicado, o carrinho existe (carrinhoId > 0) e volta sem os
  // itens filtrados, e isso é um resultado legítimo.
  if (model.length > 0 && !(serverCart?.carrinhoId > 0)) {
    const error = new Error("CART_SYNC_NOT_CONFIRMED");
    error.response = getCurrentCartresponse;
    throw error;
  }

  localStorage.setItem(
    `@ConexaoGAM:cart#${userUuid}`,
    JSON.stringify(serverCart ?? { carrinhoId: null, itens: [] })
  );
  localStorage.removeItem(`@ConexaoGAM:cart`);
}

export async function addItemsToCart(items) {
  const response = await api.post(`/cart/items`, items);
  return response.data;
}

export async function getCartInfoByHashId(cartHashId) {
  const cartInfoResponse = await api.get(`/cart/${cartHashId}`);
  return cartInfoResponse.data;
}